import { useMemo } from "react";
import { resolveSelection, formatClassDate } from "../lib/form";
import { openWorkoutAsPdf } from "../lib/pdf";
import type { Selection } from "../lib/types";

interface Props {
  selection: Selection;
  onBack: () => void;
}

export function Preview({ selection, onBack }: Props) {
  const exercises = useMemo(() => resolveSelection(selection), [selection]);
  const date = formatClassDate(selection.classDate);
  const today = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  function handleDownload() {
    openWorkoutAsPdf({
      date,
      generatedOn: today,
      exercises: exercises.map((re) => ({
        title: re.exercise.title,
        body: re.exercise.body,
      })),
    });
  }

  return (
    <div className="preview">
      <div className="preview__bar no-print">
        <button onClick={onBack} className="btn btn--ghost">
          ← Edit
        </button>
        <button
          onClick={handleDownload}
          className="btn btn--primary"
          disabled={exercises.length === 0}
        >
          Download
        </button>
      </div>

      <article className="workout">
        <header className="workout__header">
          <div className="workout__brand">Workout Plan</div>
          <h1 className="workout__title">
            Workout for {date || "—"}
          </h1>
        </header>

        {exercises.length === 0 ? (
          <p className="workout__empty">
            No exercises selected. Go back and choose your class.
          </p>
        ) : (
          <ol className="workout__list">
            {exercises.map((re, i) => (
              <li key={i} className="exercise">
                <h2 className="exercise__title">{re.exercise.title}</h2>
                {re.exercise.body.length > 0 && (
                  <ul className="exercise__lines">
                    {re.exercise.body.map((line, j) => (
                      <li key={j}>{line}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ol>
        )}

        <footer className="workout__footer">
          Created on {today}
        </footer>
      </article>
    </div>
  );
}
